import { Database } from "../supabase.types";
import { SupabaseClient } from "@supabase/supabase-js";

// coorosponding SQL:
//   CREATE TYPE social_media_type AS ENUM (
//     'Twitter', 'Instagram', 'Facebook',
//     'Youtube',  'TikTok', 'LinkedIn', 'Custom');
//
// Note that you cannot remove values from the Postgres enum.
// To add new values, see https://www.postgresql.org/docs/current/sql-altertype.html
//   ALTER TYPE name ADD VALUE [ IF NOT EXISTS ]
//     new_enum_value [ { BEFORE | AFTER } neighbor_enum_value ]

export interface SocialMediaProps {
  type: SocialMediaDataTypesEnum;
  link: string;
  letter?: string;
}

export type SocialMediaLinkRow =
  Database["public"]["Tables"]["comedian_social_media_links"]["Row"];

export type SocialMediaLinkInsert =
  Database["public"]["Tables"]["comedian_social_media_links"]["Insert"];

export type SocialMediaDataTypesEnum =
  Database["public"]["Enums"]["social_media_type"];

export function processSocialMediaLinkData(
  data: SocialMediaLinkRow
): SocialMediaProps {
  const socialMediaLink: SocialMediaProps = {
    type: data.social_media_type,
    link: data.link,
  };
  if (data.letter) {
    socialMediaLink.letter = data.letter;
  }
  return socialMediaLink;
}

export async function upsertSocialMediaLink(
  supabase: SupabaseClient<Database>,
  payload: SocialMediaLinkInsert[]
) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.user) {
    throw new Error(
      "Supabase client must have an active session to update/insert a social media link."
    );
  }

  const { count, status, error } = await supabase
    .from("comedian_social_media_links")
    .upsert(payload, {
      onConflict: "social_media_type,comedian_id",
      ignoreDuplicates: false,
      count: "exact",
    });

  if (error) {
    console.error(error);
    return { error: error };
  } else if (status === 201) {
    if (count === payload.length) {
      return { error: null };
    } else {
      // Log in Sentry that something happened that caused row count update to be not 1
      throw new Error(
        `Unexpected row count was different than 1 for creation/update of social media links for comedian with id: ${payload[0].comedian_id}`
      );
    }
  }
}

export async function deleteOneSocialMediaLink(
  supabase: SupabaseClient<Database>,
  social_media_type: SocialMediaDataTypesEnum,
  comedian_id: string
) {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.user) {
    throw new Error(
      "Supabase client must have an active session to delete social media links."
    );
  }

  const { status, error } = await supabase
    .from("comedian_social_media_links")
    .delete()
    .match({ comedian_id, social_media_type });

  if (error) {
    console.error(error);
    return { error: error };
  } else if (status === 204) {
    return { error: null };
  }

  throw new Error(
    `Error deleting social media link of type ${social_media_type} for comedian: ${comedian_id}`
  );
}
